import {Stack, Typography} from '@mui/material'
import React, {useEffect, useRef} from 'react'
import {TRANSACTION_TYPE_ENUM} from '@/types/enums'
import {TransactionInterface} from '@/types/types'
import formatDate from '@/helpers/FormatDateFromApi'

const differentAmountChange = {
  [TRANSACTION_TYPE_ENUM.ALL]: '',
  [TRANSACTION_TYPE_ENUM.BUY]: '-',
  [TRANSACTION_TYPE_ENUM.SELL]: '+',
  [TRANSACTION_TYPE_ENUM.WITHDRAW]: 'withdraw',
  [TRANSACTION_TYPE_ENUM.DEPOSIT]: 'pending',
}

interface TransactionListProps {
  transactions: TransactionInterface[]
  setPage: any
  scrollRef: any
  scrollTopRef: any
}

const Index = ({
  transactions,
  setPage,
  scrollRef,
  scrollTopRef,
}: TransactionListProps) => {
  const transactionsRef = useRef<HTMLDivElement | null>(null)

  const handleScroll = () => {
    const {scrollTop, scrollHeight, clientHeight} =
      transactionsRef.current || {}
    if (
      scrollTop !== undefined &&
      clientHeight !== undefined &&
      scrollHeight !== undefined
    ) {
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        if (scrollRef.current) return
        scrollRef.current = true
        scrollTopRef.current = scrollTop
        setPage((prev: any) => prev + 1)
      }
    }
  }

  useEffect(() => {
    const container = transactionsRef.current

    if (container) {
      if (transactions.length > 0) {
        if (transactions.length > 10) {
          container.scrollTop = scrollTopRef.current
        }
      }
    }

    if (transactions.length % 10 > 0) {
      return
    }

    if (container) {
      container.addEventListener('scroll', handleScroll)
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll)
      }
    }
  }, [transactions])

  return (
    <Stack
      className="events-block"
      height="100%"
      gap="40px"
      boxSizing="border-box"
      marginTop="20px"
      ref={transactionsRef}
      justifyContent={transactions.length === 0 ? 'center' : ''}>
      {transactions.map((transaction, index) => {
        const date = formatDate(transaction.created_at)
        return (
          <Stack
            direction="row"
            alignItems="center"
            key={'transaction-' + index}>
            <Stack width="50%" gap="5px">
              <Typography variant="body2" style={{wordBreak: 'break-word'}}>
                {transaction.description}
              </Typography>
            </Stack>
            <Stack width="25%">
              <Typography variant="body2" textAlign="center">
                {differentAmountChange[transaction.type]}&nbsp;
                {transaction.obj && (
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_SHARE_BASE_URL}${transaction.obj?.icon_img ? transaction.obj.icon_img : ''}`}
                    style={{
                      width: '20px',
                      height: '20px',
                      margin: '0px 3px -4px 3px',
                    }}
                  />
                )}
                {transaction.amount}&nbsp;{transaction.obj?.name || ''}
              </Typography>
            </Stack>
            <Stack width="25%" textAlign="center" gap="5px">
              <Typography variant="body2">
                {`${date.hours}:${date.minutes}`}
              </Typography>
              <Typography variant="body2">
                {`${date.year}-${date.month}-${date.day}`}
              </Typography>
            </Stack>
          </Stack>
        )
      })}
    </Stack>
  )
}

export default Index
